import { CmsApplianceDetailsModelSerialPage } from '../../models/appliance-details-model-serial/cms-appliance-details-model-serial-page.interface';
import { mockCmsRegistrationRoot } from '../cms/cms-registration-root.mock';
import { mockCmsApplianceDetailsModelSerialApplianceExists } from './cms-appliance-details-model-serial-appliance-exists.mock';
import { mockCmsApplianceDetailsModelSerialBenefitsPanel } from './cms-appliance-details-model-serial-benefits-panel.mock';
import { mockCmsApplianceDetailsModelSerialConfirmation } from './cms-appliance-details-model-serial-confirmation.mock';
import { mockCmsApplianceDetailsModelSerialExpiredLink } from './cms-appliance-details-model-serial-expired-link.mock';
import { mockCmsApplianceDetailsModelSerialForm } from './cms-appliance-details-model-serial-form.mock';

export const mockCmsApplianceDetailsModelSerialPage: CmsApplianceDetailsModelSerialPage =
  {
    ...mockCmsRegistrationRoot,
    ...mockCmsApplianceDetailsModelSerialForm,
    applianceDetailsModelSerialBenefitsPanel:
      mockCmsApplianceDetailsModelSerialBenefitsPanel,
    applianceDetailsModelSerialConfirmation:
      mockCmsApplianceDetailsModelSerialConfirmation,
    applianceDetailsModelSerialApplianceExists:
      mockCmsApplianceDetailsModelSerialApplianceExists,
    applianceDetailsModelSerialExpiredLink:
      mockCmsApplianceDetailsModelSerialExpiredLink,
  };
